<template>

    <b-modal :active.sync="isComponentModalActive"
             has-modal-card full-screen >

        <div class="modal-card ">
            <section class="modal-card-body"  >
                <b-loading  :active.sync="isFullScreenLoading" />
<!--                <div>-->
<!--                    <b-field label="Filter Params" v-for="dataMasterLabKind in dataMasterLabKinds" :key="dataMasterLabKind.name">-->
<!--                        <b-field grouped>-->
<!--                            <p class="control">-->
<!--                                <button class="button">{{dataMasterLabKind.name}}</button>-->
<!--                            </p>-->
<!--                            <b-numberinput v-model="dataMasterLabKind.number_date_warning"/>-->
<!--                        </b-field>-->
<!--                    </b-field>-->
<!--                </div>-->

                <b-button type="is-success" outlined  @click="loadWarninglabUnpublishGetData" :disabled="!checkedRows.length>0">Refresh or Reload </b-button>
                &nbsp;
                <b-button type="is-success" outlined  @click="updateWarninglabUnpublishConditions">Update Default Data</b-button>
                <b-table
                        :data="isEmpty ? [] : warninglabunpublishconditions "
                        mobile-cards
                        :checked-rows.sync="checkedRows"
                        checkable
                        style="width: 50%"
                >
                    <b-table-column  label="Lab Kind" centered v-slot="props">
                        <p class="is-size-5">{{ props.row.name }}</p>
                    </b-table-column>

                    <b-table-column  label="Number of Days" centered v-slot="props">
                        <b-numberinput v-model=" props.row.number_date_warning" min="1" max="365"/>
                    </b-table-column>

                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>



                </b-table>
                <b-taglist>
                    <b-tag type="is-info" v-for="checkedRow in checkedRows" :key="checkedRow.id" size="is-medium">
                        {{checkedRow.name}}
                        <span  >   <b-tag  type="is-danger" rounded  style="margin-top: 5px;" > {{checkedRow.number_date_warning}} </b-tag> Days </span>
                    </b-tag>
                </b-taglist>


                <hr>

                <b-tabs v-model="activeTab" v-if="dataWarninglabUnpublishs.length>0" >
                    <template v-for="dataWarninglabUnpublish   in dataWarninglabUnpublishs">
                        <b-tab-item
                                :key="dataWarninglabUnpublish.name"
                                :value="dataWarninglabUnpublish.name"
                                :label="dataWarninglabUnpublish.name">
                        <WarningLabUnPublish_Data :name="dataWarninglabUnpublish.name" :dataEach="dataWarninglabUnpublish.dat"/>
                        </b-tab-item>
                    </template>
                </b-tabs>




            </section>








            <footer class="modal-card-foot">
                <b-button size="is-medium" type="is-danger"
                          icon-left="close" @click="closeModal">
                    Close
                </b-button>
            </footer>
        </div>

    </b-modal>



</template>

<script>
    import { getBaseURLforBackEnd  , getConfigAxios   } from '@/utils.js'
    import {mapState, mapActions  } from 'vuex'
    import axios from "axios";
    import WarningLabUnPublish_Data from "./WarningLabUnPublish_Data";

    export default {
        name: "WarningLabUnPublish",
        components:{
            WarningLabUnPublish_Data
        },
        methods:{
            ...mapActions({
                fetchWarninglabUnpublishConditions : 'admin/fetchWarninglabUnpublishConditions',
            }),
            updateWarninglabUnpublishConditions(){
                this.isFullScreenLoading = true
                const vm = this
                var  arrDatTo = []
                for(var i = 0 ; i<= this.warninglabunpublishconditions.length-1 ;i++){
                    arrDatTo.push( {"id_status": this.warninglabunpublishconditions[i].id ,
                                    "number_date_warning": this.warninglabunpublishconditions[i].number_date_warning })
                }
                const datTo = {
                    "data_req" : arrDatTo
                }

                // console.log(JSON.stringify(datTo))
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatewarninglabunpublishconditions`,datTo,getConfigAxios())
                     .then((res)=>{
                         setTimeout(()=>{
                             vm.isFullScreenLoading = false
                             vm.$buefy.toast.open({
                                 message: `${res.data.msg}`,
                                 type: 'is-success'
                             })
                         },1000)

                     })
                     .catch((err)=>{
                         vm.isFullScreenLoading = false
                         vm.$buefy.dialog.alert({
                             title: 'Error',
                             message: `${err}`,
                             type: 'is-danger',
                             hasIcon: true,
                             icon: 'times-circle',
                             iconPack: 'fa',
                             ariaRole: 'alertdialog',
                             ariaModal: true
                         })
                     })


            },
            init(){
                const vm = this
                this.isFullScreenLoading = true
                this.checkedRows = []
                this.dataWarninglabUnpublishs = []
                this.activeTab = null
                this.fetchWarninglabUnpublishConditions()
                    .then(()=>{
                        setTimeout(()=>{
                            vm.isFullScreenLoading = false
                        },1000)
                    })
                    .catch(err=>{
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Error  from ${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },
            loadWarninglabUnpublishGetData(){
                const arrTmp = this.checkedRows.map(dat=>{
                    return {
                        "id_status"  : dat.id,
                        "number_date_warning" : dat.number_date_warning
                     }
                })
                const datTo = {
                           "data_req" : arrTmp
                }

                const vm = this
                this.isFullScreenLoading = true
                this.dataWarninglabUnpublishs = []
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/warninglabunpublishgetdata`,datTo,getConfigAxios())
                    .then((res)=>{
                        setTimeout(()=>{
                            vm.isFullScreenLoading = false
                            vm.dataWarninglabUnpublishs = res.data
                            // console.log(JSON.stringify( vm.dataWarninglabUnpublishs ))
                            if (vm.dataWarninglabUnpublishs.length>0 ){
                                vm.activeTab = 0
                            }
                        },1000)


                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },






            closeModal(){
              this.isComponentModalActive = false
            },
        },
        computed:{
            ...mapState({
                warninglabunpublishconditions : state => state.admin.warninglabunpublishconditions,
                access_token: state => state.master_data.access_token,
            })

        },
        mounted() {
            //console.log('mount WarningLabUnPublish')
            this.fetchWarninglabUnpublishConditions()
        },
        data(){

            return {
                isComponentModalActive : false,
                isFullScreenLoading : false,
                // dataMasterLabKinds : [{"id":1 ,"name": "Cytology","number_date_warning": 4} ,
                //                       {"id":2 ,"name": "Biopsy","number_date_warning": 5} ,
                //                      ],
                checkedRows: [],
                isEmpty: false,
                dataWarninglabUnpublishs:[],
                activeTab : null
            }
        }
    }
</script>

<style scoped>

</style>